module.exports = __webpack_public_path__ + "static/media/Oshawott_gaussian2.15e8a340.png";